// Constants
import { TARGET_RATES_APP_STATE_SLICE_KEY } from 'TargetRatesApp/apps/target-rates-app/state/constants';
// Services
import { AppStateService } from 'NewAngular/services/app-state.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/app-state.service";
export class TargetRatesAppStateService {
    constructor(appStateService) {
        this.appStateService = appStateService;
    }
    initAppState() {
        this.appStateService.setStateSlice(TARGET_RATES_APP_STATE_SLICE_KEY);
        this.appStateService.start();
    }
    resetToSystemDefault() {
        this.appStateService.resetToSystemDefaultState();
    }
}
TargetRatesAppStateService.ɵfac = function TargetRatesAppStateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TargetRatesAppStateService)(i0.ɵɵinject(i1.AppStateService)); };
TargetRatesAppStateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TargetRatesAppStateService, factory: TargetRatesAppStateService.ɵfac, providedIn: 'root' });
